<template>
  <span class="floating__case-study" v-bind:class="caseColor">
    <transition 
      appear
      mode="out-in"
      @appear="enterText"
      @enter="enterText"
      @leave="leaveText">
      
        <p  v-show="showChild">{{ caseText }}</p>     

    </transition> 
  </span>
</template>

<script>
export default {
  name: "FloatingCaseStudy",
  data() {
    return {};
  },
  methods: {
    enterText: function(el, done) {
      TweenMax.fromTo( el, .5,
        { y: "155%" },
        {
          ease: Power3.easeOut,
          y: "0%",
          delay: .2,
          onComplete: done
        }
      );
    },
    leaveText: function(el, done) {
      TweenMax.to(el, .5, {
        y: "-155%",
        ease: Power3.easeOut,
        onComplete: done
      });
    }
  },
  props: ["caseColor", "caseText", "showChild"]
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/FloatingCaseStudy.vue